import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getArticles, getArticle } from '@/lib/articlesApi';
import { InterviewMapperService } from '@/services/interview/management/base/interviewMapperService';

export const useLocalizedInterviews = (limit = 10, filters?: { tag?: string; person?: string; question?: string }) => {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: ['articles', i18n.language],
    queryFn: async () => {
      const data = await getArticles({ limit, ...filters });
      return Array.isArray(data) ? data.map(interview => InterviewMapperService.mapDatabaseInterviewToModel(interview)) : [];
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};

export const useLocalizedInterviewsByTag = (tag: string, limit = 10) => {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: ['articles', i18n.language, 'tag', tag],
    queryFn: async () => {
      const data = await getArticles({ limit, tag });
      return Array.isArray(data) ? data.map(interview => InterviewMapperService.mapDatabaseInterviewToModel(interview)) : [];
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};

export const useLocalizedInterviewsByPerson = (person: string, limit = 10) => {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: ['articles', i18n.language, 'person', person],
    queryFn: async () => {
      const data = await getArticles({ limit, person });
      return Array.isArray(data) ? data.map(interview => InterviewMapperService.mapDatabaseInterviewToModel(interview)) : [];
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};

export const useLocalizedInterviewsByQuestion = (question: string, limit = 10) => {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: ['articles', i18n.language, 'question', question],
    queryFn: async () => {
      const data = await getArticles({ limit, question });
      return Array.isArray(data) ? data.map(interview => InterviewMapperService.mapDatabaseInterviewToModel(interview)) : [];
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};

export const useLocalizedInterview = (id: string) => {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: ['article', id, i18n.language],
    queryFn: async () => {
      const data = await getArticle(id);
      return data ? InterviewMapperService.mapDatabaseInterviewToModel(data) : null;
    },
    enabled: !!id,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};